// require("./lib/social");
// require("./lib/ads");
// var track = require("./lib/tracking");

require("component-responsive-frame/child");


var Chartist = require("chartist");
var $ = require("jquery");

function commafy(num) {
  num = num.toString();
  if (!num) return;
  if (num.length >= 4) {
    num = num.replace(/(\d)(?=(\d{3})+$)/g, '$1,');
  }
  return num;
}



var data = {
  labels: ["2011", "2012", "2013", "2014", "2015", "2016"],
  series: [{
    name: 'Chronically homeless',
    data: [1914, 1422, 1309, 769, 600, 467]
  }, {
    name: 'Homeless families',
    data: [2178, 1566, 1565, 1390, 1243, 841]
  }, {
    name: 'Homeless veterans',
    data: [1146, 1162, 877, 644, 563, 537]
  }]
}
var options = {
  seriesBarDistance: 22,
  stackBars: false,

  axisY: {
    offset: 30,
    labelInterpolationFnc: function(value) {
      return (commafy(value));
    },

    labelOffset: {
      x: 6,
      y: 6
    }
  },
  axisX: {
    labelInterpolationFnc: function(value, index) {
      return index % 1 === 0 ? value : null;
    }
  },

  labelDirection: 'explode'
};
var responsiveOptions = [
  ['screen and (min-width: 641px) and (max-width: 1024px)', {
    seriesBarDistance: 22,
    axisX: {
      labelInterpolationFnc: function (value) {
        return value;
      }
    }
  }],
  ['screen and (max-width: 640px)', {
    seriesBarDistance: 12,
    axisX: {
      // labelInterpolationFnc: function (value) {
      //   return value[0];
      // }
    }
  }]
];



var $chart = $('#chart2');

var $toolTip = $chart
  .append('<div class="tooltip"></div>')
  .find('.tooltip')
  .hide();

$chart.on('mouseenter', '.ct-bar', function() {
  var $bar = $(this),
    value = $bar.attr('ct:value'),
    seriesName = $bar.parent().attr('ct:series-name');
  $toolTip.html('<span class="popuptitle">' + seriesName + '</span><br><div class="popuptext">' + (commafy(value)) + '</div>').show();
});

$chart.on('mouseleave', '.ct-bar', function() {
  $toolTip.hide();
});

$chart.on('mousemove', function(e) {
  var bounds = $chart[0].getBoundingClientRect();
  var mouse = {
    left: e.clientX,
    top: e.clientY
  };
  var tWidth = $toolTip.width();
  var position = {
    left: mouse.left - bounds.left - tWidth / 2,
    top: mouse.top - bounds.top - $toolTip.height() - 30
  };
  if (position.left < 0) position.left = 0;
  if (position.left + tWidth > bounds.width) position.left = bounds.width - tWidth;
  position.left += "px";
  position.top += "px";
  $toolTip.css(position);
});

new Chartist.Bar('#chart2', data, options, responsiveOptions);
